import BackgroundColors from '@root/joinroot.com/src/utils/background-colors';
import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import { Eyebrow, H2, P1 } from '@root/joinroot.com/src/components/text';
import { StyleSheet } from '@root/core/src/utils/styles';

export default function ImageToutSideBySideSection({
  anchor,
  backgroundColor = BackgroundColors.cmsValues.WHITE,
  body,
  children,
  eyebrow,
  title,
}) {
  return (
    <section
      css={[
        styles.imageToutContainer,
        styles.anchorSpacer,
        BackgroundColors.getBackgroundStyle(backgroundColor),
      ]}
      id={anchor}
    >
      {(eyebrow || title || body) &&
        <div css={styles.headingContainer}>
          {eyebrow && <Eyebrow css={styles.eyebrow}>{eyebrow}</Eyebrow>}
          {title && <H2 css={styles.title}>{title}</H2>}
          {body && <P1 css={styles.body}>{body}</P1>}
        </div>
      }
      <div css={styles.childrenContainer}>
        {children}
      </div>
    </section>
  );
}

const styles = StyleSheet.create({
  imageToutContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  anchorSpacer: {
    '&:before': {
      display: 'block',
      content: '" "',
      marginTop: -110,
      height: 110,
      visibility: 'hidden',
      pointerEvents: 'none',
    },
  },
  headingContainer: {
    maxWidth: 350,
    marginTop: 80,
    '@media screen and (min-width: 768px)': {
      maxWidth: 700,
      marginTop: 100,
    },
  },
  eyebrow: {
    marginBottom: 15,
  },
  title: {
    marginTop: 0,
    marginBottom: 15,
  },
  childrenContainer: {
    width: '100%',
  },
});

ImageToutSideBySideSection.propTypes = {
  anchor: PropTypes.string,
  backgroundColor: PropTypes.oneOf(BackgroundColors.cmsValueList),
  body: PropTypes.node,
  children: PropTypes.node.isRequired,
  eyebrow: PropTypes.node,
  title: PropTypes.node,
};
